export const apiUrl = 'https://api.haha.rw';
